<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OzWYhA/tc-custom/9781421410395.jpg?1706909644127" alt="This image is the cover for the book Faces of the Civil War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faces of the Civil War
      </h1>
      <p class="bookDescription body article font2">
        <b>Archival images and biographical sketches of Union soldiers tell the stories of their lives during and after the Civil War.</b><br/><br/>Before leaving to fight in the Civil War, many Union and Confederate soldiers posed for a <i>carte de visite</i>, or visiting card, to give to their families, friends, or sweethearts. Invented in 1854 by a French photographer, the <i>carte de visite</i> was a small photographic print roughly the size of a modern trading card. The format arrived in America on the eve of the Civil War, fueling intense demand for the keepsakes. Many cards of Civil War soldiers survive today, but the experiences?and often the names?of the individuals portrayed have been lost to time. A passionate collector of Civil War–era photography, Ron Coddington researched the history behind these anonymous faces in military records, pension files, and other public and personal documents.<br/><br/>In <i>Faces of the Civil War</i>, Coddington presents 77 <i>cartes de visite</i> of Union soldiers from his collection and tells the stories of their lives during and after the war. These soldiers came from all walks of life. All were volunteers. Their personal stories reveal a tremendous diversity in their experience of war: many served with distinction, some were captured, some never saw combat while others saw little else. The lives of survivors were even more disparate. While some made successful transitions back to civilian life, others suffered permanent physical and mental disabilities, which too often wrecked their families and careers. In compelling words and haunting pictures, <i>Faces of the Civil War</i> offers a unique perspective on the most dramatic and wrenching period in American history.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ronald S Coddington, Michael Fellman
      </h2>
      
      <p class="authorDescription body article">Ron Coddington is a visual journalist whose work has appeared in USA Today, The Atlanta Journal-Constitution, and the San Jose Mercury News. He currently writes a monthly column, "Faces of War," for The Civil War News. He lives in Arlington, Virginia, with his wife, Anne.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d13eefd0